import { Directive } from 'vue'
import { style, css, boundingRect } from '@/utils/dom'

const draggable: Directive<HTMLDivElement> = {
  mounted(el) {
    const positionStr = style(el, 'position')
    if (positionStr === 'static') {
      return
    }

    const cursor = style(el, 'cursor')
    const contain = style(el, 'contain')
    const { width, height } = boundingRect(el)

    css(el, { position: 'absolute' })
    el.addEventListener('mousedown', onMouseDown, false)

    function onMouseDown() {
      css(el, { cursor: 'move', userSelect: 'none', contain: 'strict' })
      document.addEventListener('mousemove', onMouseMove, false)
      document.addEventListener('mouseup', onMouseUp, false)
    }

    function onMouseMove(e: MouseEvent) {
      const { movementX, movementY } = e
      const bodyClientWidth = document.body.clientWidth
      const bodyClientHeight = document.body.clientHeight
      const getStyle = getComputedStyle(el)
      const curLeft = Number.parseInt(getStyle.getPropertyValue('left'))
      const curTop = Number.parseInt(getStyle.getPropertyValue('top'))
      const nextLeft = curLeft + movementX
      const nextTop = curTop + movementY
      const left = Math.max(0, Math.min(bodyClientWidth - width, nextLeft))
      const top = Math.max(0, Math.min(bodyClientHeight - height, nextTop))

      css(el, {
        left: left + 'px',
        top: top + 'px',
      })
    }

    function onMouseUp() {
      css(el, { cursor, contain })
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
    }
  },
}

export default {
  name: 'draggable',
  definition: draggable,
}
